module.exports = __webpack_public_path__ + "static/13-5e5a8e52e9411b7b1b5a423de8939ed5.jpeg";